import React from "react";
import { X, RotateCw, Star, Award, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * CameraHeader — top bar of the camera overlay.
 * Shows post-type badge, close button, and flip-camera button.
 */
const CameraHeader = ({
	postType,
	isContest,
	onClose,
	hasMultipleCameras,
	capturedImage,
	capturedVideo,
	capturedAudio,
	mode,
	facingMode,
	onFlipCamera,
}) => {
	const showFlip =
		hasMultipleCameras &&
		!capturedImage &&
		!capturedVideo &&
		!capturedAudio &&
		mode !== "audio";

	return (
		<div className="absolute left-0 right-0 top-0 z-10 flex items-start justify-between bg-gradient-to-b from-black/80 to-transparent p-4">
			{/* Left side — post type badge */}
			<div className="flex flex-col gap-2">
				{(postType || isContest) ? <div>
						{isContest ? <div className="flex items-center gap-2 rounded-full bg-blue-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Star size={16} />
								<span>Contest Submission</span>
							</div> : null}
						{!isContest && postType === "glow" && (
							<div className="flex items-center gap-2 rounded-full bg-yellow-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Star size={16} />
								<span>Glow Post</span>
							</div>
						)}
						{!isContest && postType === "pride" && (
							<div className="flex items-center gap-2 rounded-full bg-purple-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Award size={16} />
								<span>Proud Post</span>
							</div>
						)}
						{!isContest && postType === "grateful" && (
							<div className="flex items-center gap-2 rounded-full bg-green-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Heart size={16} />
								<span>Grateful Post</span>
							</div>
						)}
					</div> : null}
			</div>

			{/* Right side — close + flip */}
			<div className="flex flex-col gap-2">
				<Button
					onClick={onClose}
					variant="ghost"
					size="icon"
					className="bg-red-500 text-white hover:bg-red-600"
				>
					<X size={24} />
				</Button>

				{showFlip ? <Button
						onClick={onFlipCamera}
						variant="ghost"
						size="icon"
						className="text-white hover:bg-white/20 md:hidden"
						title="Flip camera"
					>
						<RotateCw size={24} />
					</Button> : null}
			</div>
		</div>
	);
};

export default CameraHeader;
